// extracted by mini-css-extract-plugin
export default {"support":"Support_support__d-+AY","wrapper":"Support_wrapper__R-2r3","heading":"Support_heading__+qZAR","para":"Support_para__CynJx"};